import { Stack, styled, Tooltip, tooltipClasses } from '@mui/material'
import {
  ContentWrap,
  Flex,
  FlexBetween,
  FlexCenter,
  specifyTheme,
} from 'styles'
import { darkColor } from '../../styles/constants/dark'
import { lightColor } from '../../styles/constants/light'
import { HeaderTip } from '../Deposit/DepositSelectAssets'

export const HeaderTipValue = styled(HeaderTip)`
  display: flex;
  justify-content: space-between;
`
export const ContentSwapFlex = styled(ContentWrap)`
  padding: 0;
  ${(props) => props.theme.breakpoints.down('md')} {
    display: block;
  }
`
export const WithdrawSelectWrap = styled('div')`
  ${(props) => props.theme.breakpoints.down('md')} {
    max-height: 70vh;
    overflow: auto;
    padding-bottom: unset;
  }
`
export const SupportButtons = styled('div')`
  display: flex;
  align-items: center;

  > div {
    width: 120px;
    height: 40px;
    border-radius: 20px;
    margin-right: 12px;
    color: rgba(255, 255, 255, 1);
    border: 1px solid rgba(46, 54, 59, 1);
    display: flex;
    font-size: 16px;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    &:hover {
      border: 1px solid ${(props) => props.theme.color.text30};
    }
    &.active {
      color: rgba(160, 238, 9, 1);
      font-weight: 600;
      border-color: rgba(160, 238, 9, 1);
      &:hover {
        border: 1px solid ${(props) => props.theme.color.primary30};
      }
    }
  }
  .icon-fast {
    margin-right: 8px;
  }
  .icon-selected {
    margin-left: 8px;
  }
`

export const FromTip = styled('div')`
  color: rgba(149, 164, 173, 1);
  font-size: 14px;
  line-height: 20px;

  b {
    color: rgba(202, 213, 220, 1);
  }
`
export const BootstrapTooltip = styled(Tooltip)(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.black,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.black,
  },
}))
export const AddressBookIconWrap = styled(FlexCenter)`
  margin-left: 12px;
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  width: 24px;
  height: 24px;
  cursor: pointer;
  border-radius: 50%;
  .iconfont {
    color: ${(props) => props.theme.color.text00};
  }
`
export const AddressDetectedWrap = styled(Flex)`
  padding: 8px 16px;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  background-color: ${(props) => props.theme.color.primary10};
  color: ${(props) => props.theme.color.text80};
  border-radius: 6px;
  border: 1px solid ${(props) => props.theme.color.primary30};
  cursor: pointer;
  white-space: pre;
  span {
    font-weight: 600;
    color: ${(props) => props.theme.color.primary40};
  }
  ${(props) => props.theme.breakpoints.down('md')} {
    font-size: 12px;
    justify-content: center;
  }
`
export const Popup = styled(Stack)`
  gap: 8px;
  z-index: 10;
  position: absolute;
  right: 24px;
  left: 24px;
  padding: 16px 0;
  border-top: 1px solid rgba(160, 238, 9, 1);
  border-radius: 0 0 4px 4px;
  box-shadow:
    0px 0px 2px rgba(0, 0, 0, 0.12),
    0px 10px 15px -3px rgba(0, 0, 0, 0.12),
    0px 4px 6px -2px rgba(0, 0, 0, 0.04);
  background: rgba(42, 49, 57, 1);
`
export const AddressBookList = styled(Flex)`
  flex-direction: column;
  gap: 8px;
  /* padding: 4px 8px; */
  /* gap: 4px; */
  max-height: 210px;
  overflow-y: auto;
`
export const AddressBookListItem = styled(Flex)`
  padding: 6px 12px;
  align-items: center;
  position: relative;
  cursor: pointer;

  &:hover {
    background-color: rgba(57, 65, 73, 1);
  }

  &.checked {
    background-color: rgba(160, 238, 9, 0.1);

    &::before {
      content: '';
      width: 2px;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      background-color: rgba(160, 238, 9, 1);
    }
  }
`
export const WalletName = styled('div')`
  flex: 1;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: ${(props) => props.theme.color.text100};
  &.collection {
    font-weight: 600;
  }
`
export const WalletActionWrap = styled(Flex)`
  align-items: center;
  gap: 8px;
`
export const WalletAction = styled(Flex)`
  align-items: center;
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
  color: ${(props) => props.theme.color.text100};
  padding: 0 8px;
  border-radius: 9px;
  background-color: rgba(14, 203, 129, 1);

  &.delete {
    background-color: rgba(246, 70, 93, 1);
  }
`
export const WalletAddress = styled(Flex)`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: rgba(202, 213, 220, 1);
`
export const CurrentUseAddressWrap = styled(Flex)`
  flex: 1;
  align-items: center;
  color: ${(props) => props.theme.color.text90};
  font-size: 16px;
  line-height: 24px;
  white-space: pre;
`
export const CurrentUseWalletName = styled('div')`
  font-weight: 600;
  strong {
    font-weight: 700;
  }
`
export const CurrentUseAddress = styled('div')`
  font-weight: 400;
`
export const CurrentAddress = styled(Flex)`
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  color: ${(props) => props.theme.color.text90};
  font-size: 16px;
  line-height: 24px;
  align-items: center;
  background: rgba(22, 25, 30, 1);
  /* background: ${(props) => props.theme.color.bg}; */
  padding: 0 12px;
  border-radius: 6px;
  cursor: text;
  strong {
    font-weight: 700;
  }
  white-space: pre;
`

export const AccountImpactWrap = styled(FlexBetween)`
  font-weight: 400;
  font-size: 12px;
  line-height: 24px;
  color: ${(props) => props.theme.color.text70};
`

export const AccountImpactItemWrap = styled(FlexCenter)`
  gap: 4px;
  .right {
    display: flex;
    align-items: center;
  }
`
